import React, { Component } from 'react';
import newId from '../../utils/newid';

class TextInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      hasChanged: false
    };
  }

  componentWillMount() {
    this.id = newId();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({ active: true });
    }

    if (typeof nextProps.id !== 'undefined' && nextProps.id.length > 0) {
      this.id = this.props.id;
    }
  }

  focus() {
    this.refs[this.id].focus();
  }

  handleChange(e) {
    // Makes sure the component was given an onChange property function
    if (typeof this.props.onChange === 'function') {
      this.setState({ hasChanged: true });
      this.props.onChange(e);
    } else {
      console.error('TextInput requires an onChange handler');
    }
  }

  handleFocus(e) {
    this.setState({ active: true });
  }

  handleBlur(e) {
    if (this.props.value && this.props.value.length === 0) {
      this.setState({ active: false });
    }

    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(e);
    }
  }

  render() {
    let classes = ['text-input'];

    if (typeof this.props.className !== 'undefined') {
      classes.push(this.props.className);
    }

    let inputClasses = [];

    if (typeof this.props.inputClass !== 'undefined') {
      inputClasses.push(this.props.inputClass);
    }

    if (!this.props.disabled) {
      if (typeof this.props.valid !== 'undefined' && this.props.valid.toString().length > 0) {
        if (this.props.valid) {
          inputClasses.push('valid');
        } else {
          inputClasses.push('invalid');
        }
      }
    }

    return (
      <div className={classes.join(' ')}>
        <div className="input-field">
        {
          this.props.iconPrefix ?
            <i
              className="material-icons prefix"
              onClick={this.props.onIconClick ? this.props.onIconClick : null}>{this.props.iconPrefix}</i>
            : ''
        }
          <input
            autoComplete={this.props.autoComplete || null}
            className={inputClasses.join(' ')}
            disabled={this.props.disabled || false}
            id={this.id}
            max={this.props.max || null}
            maxLength={this.props.maxLength || null}
            min={this.props.min || null}
            noValidate={this.props.noValidate || false}
            onBlur={this.handleBlur.bind(this)}
            onChange={this.handleChange.bind(this)}
            onFocus={this.handleFocus.bind(this)}
            ref={this.id}
						onKeyPress={this.props.onKeyPress || null}
            step={this.props.step || null}
            type={this.props.type || 'text'}
            value={this.props.value} />
          <label
            className={this.props.value ? 'active' : null}
            htmlFor={this.id}
            ref="label"
            data-error={this.state.active ? this.props.error : null}
            data-success={this.props.success}>
            {this.props.label}
          </label>
        </div>
      </div>
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput/TextInput.js